<template>
  <div
    v-if="!isLoading && (branchGoal > 0 || personalGoal > 0)"
    class="row section-goals"
    :class="{'office-only' : personalGoal <= 0, 'personal-only' : branchGoal <= 0}"
  >
    <div v-if="branchGoal > 0" :class="`col-${personalGoal > 0 ? 'md-6' : '12'}`">
      <div class="card card-goals office">
        <div class="card-body">
          <h3 class="card-title" :class="{'text-center': personalGoal <= 0}">
            <strong>Office Goal - {{ branchName === '' ? 'Not set' : branchName }}</strong>
          </h3>
          <p class="period" :class="{'text-center': personalGoal <= 0}">
            {{ period ? 'On ' + period : ''}}
          </p>

          <div :class="{'row': personalGoal <= 0}">
            <div :class="{'col-md-6': personalGoal <= 0}">
              <office-goals-summary :total-goal="branchGoal" :total-actual="branchActual" :total-pending="branchPending" :personal="personalGoal > 0" />
            </div>
            <div :class="{'col-md-6': personalGoal <= 0}">
              <student-nationality type="office" :nationalities="branchStudents" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="personalGoal > 0" :class="`col-${branchGoal > 0 ? 'md-6' : '12'}`">
      <div class="card card-goals personal">
        <div class="card-body">
          <h3 class="card-title">
            <strong>My Goal</strong>
          </h3>
          <p class="period">
            {{ periodPersonal ? 'On ' + periodPersonal : ''}}
          </p>

          <div :class="{'row': branchGoal <= 0}">
            <div :class="{'col-md-6': branchGoal <= 0}">
              <my-goals-summary :goal="personalGoal" :actual="personalActual" :pending="personalPending" :contribution="contribution" />
            </div>
            <div :class="{'col-md-6': branchGoal <= 0}">
              <student-nationality type="personal" :nationalities="personalStudents" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBranchGoal, getPersonalGoal, getStudentsNationality } from "../../services/api/goals";
import OfficeGoalsSummary from "./components/OfficeGoalsSummary.vue";
import StudentNationality from "./components/StudentNationality.vue";
import MyGoalsSummary from "./components/MyGoalsSummary.vue";

import '../../../sass/dashboard/section-goals.scss'

export default {
  name: 'GoalsSection',
  components: {
    OfficeGoalsSummary,
    MyGoalsSummary,
    StudentNationality
  },
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.fetchOfficeGoals();
    this.fetchPersonalGoals();
    this.fetchStudentsNationalities();
  },
  data() {
    return {
      isLoading: false,
      period: '',
      periodPersonal: '',
      branchName: '',
      branchGoal: 0,
      branchActual: 0,
      branchPending: 0,
      personalGoal: 0,
      personalActual: 0,
      personalPending: 0,
      contribution: 0,
      branchStudents: [],
      personalStudents: []
    }
  },
  methods: {
    async fetchOfficeGoals() {
      this.isLoading = true;

      try {
        const response = await getBranchGoal(this.userId);

        if (response.status === 200) {
          this.period = response.data.period;
          this.branchName = response.data.branch_name;
          this.branchGoal = response.data.goals;
          this.branchActual = response.data.actual;
          this.branchPending = response.data.pending;
        }
      } catch (error) {
        console.error('Error fetching office goals:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchPersonalGoals() {
      this.isLoading = true;

      try {
        const response = await getPersonalGoal(this.userId);

        if (response.status === 200) {
          this.personalGoal = response.data.goals;
          this.personalActual = response.data.actual;
          this.personalPending = response.data.pending;
          this.periodPersonal = response.data.period;
          this.contribution = response.data.contribution;
        }
      } catch (error) {
        console.error('Error fetching office goals:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchStudentsNationalities() {
      this.isLoading = true;

      try {
        const response = await getStudentsNationality(this.userId);

        if (response.status === 200) {
          this.branchStudents = response.data.branch;
          this.personalStudents = response.data.personal;
        }
      } catch (error) {
        console.error('Error fetching students nationality:', error);
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>